import { MediaModel } from 'entities/MediaModel/MediaModel';
import { IMedia } from 'entities/MediaModel/types';

import { ITeamMember, IContact, TeamMemberServer } from './types';

export class TeamModel implements ITeamMember {
  readonly id: number;
  readonly name: string;
  readonly jobTitle: string;
  readonly image: IMedia;
  readonly contacts?: IContact[];

  constructor(params: ITeamMember) {
    this.id = params.id;
    this.name = params.name;
    this.jobTitle = params.jobTitle;
    this.image = params.image;
    this.contacts = params.contacts;
  }

  static fromJson(raw: TeamMemberServer): TeamModel {
    return new TeamModel({
      id: raw.id,
      name: raw.name,
      jobTitle: raw.jobTitle,
      image: MediaModel.fromJson(raw.image),
      contacts: raw.contacts?.map((c) => ({
        id: c.id,
        contact: c.contact,
        contactChannel: c.contactChannel,
      })),
    });
  }
}
